<template>
  <div id="home">
    <NavigationBar />

    <section class="uk-visible@s uk-margin-medium-bottom" id="section-one">
      <!-- DESKTOP -->
      <div class="uk-visible@s uk-margin-medium-left" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: false;">
        <div class="main-slideshow" uk-slideshow="autoplay: true; autoplay-interval: 3000">
          <div class="uk-slideshow-items centered-image">
            <div>
              <img :src="encodeURI('https://api.roomi.co.id/images/home/aset website-02.jpg')" alt="tv" uk-cover>
              <div class="uk-position-bottom uk-animation-slide-bottom uk-margin-medium-bottom flex flex-center uk-text-center uk-margin-medium-left uk-margin-medium-right">
                <!-- <p class="uk-margin-remove uk-text-white font-white uk-text-large">Smart Home Security Camera</p> -->
              </div>
            </div>
            <div>
              <img :src="encodeURI('https://api.roomi.co.id/images/home/aset website-01.jpg')" alt="speaker" uk-cover>
              <div class="uk-position-bottom uk-animation-slide-bottom uk-margin-medium-bottom flex flex-center uk-text-center uk-margin-medium-left uk-margin-medium-right">
                <!-- <p class="uk-margin-remove uk-text-white font-white uk-text-large">Smart Home Security Camera</p> -->
              </div>
            </div>
            <div>
              <img :src="encodeURI('https://api.roomi.co.id/images/home/aset website-03.jpg')" alt="tv" uk-cover>
              <div class="uk-position-bottom uk-animation-slide-bottom uk-margin-medium-bottom flex flex-center uk-text-center uk-margin-medium-left uk-margin-medium-right">
                <!-- <p class="uk-margin-remove uk-text-white font-white uk-text-large">Smart Home Security Camera</p> -->
              </div>
            </div>
          </div>
          <!-- <ul class="uk-slideshow-nav uk-dotnav uk-flex-center uk-margin centered-image"></ul> -->
        </div>
        <div class="uk-grid uk-grid-collapse" uk-grid>
          <!-- LEFT CONTENT -->
          <!-- <img class="centered-image uk-margin-large-top":src="require('../assets/images/home/promoted.jpg')" alt="TV Image"> -->

          <div class="uk-width-1-2@s uk-flex uk-flex-middle uk-position-relative">
            <div class="uk-margin-large-left uk-margin-large-right">
              <div class="uk-grid" uk-grid>
                <div class="uk-width-2-3@s">
                  <p class="font-title uk-text-bold uk-text-emphasis" uk-scrollspy="cls: uk-animation-slide-left; delay: 500; repeat: false;">Explore Our Selection of Smart Home Appliances</p>
                  <p class="font-description uk-text-light" uk-scrollspy="cls: uk-animation-slide-left; delay: 500; repeat: false;">Welcome to ROOMI, the ultimate destination for all your smart home needs. We specialize in home appliances, home speakers, portable speakers, televisions with google tv, android tv, smart cctv and many more.</p>
                  <button @click="goTo('https://tokopedia.com/roomiid')" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 800; repeat: false;" class="uk-button uk-button-primary">Shop Now</button>
                </div>
              </div>
            </div>

          </div>

          <!-- RIGHT CONTENT -->
          <div class="uk-width-1-2@s" uk-scrollspy="cls: uk-animation-slide-right; target: > img; delay: 500; repeat: true;">
            <div class="uk-position-relative uk-light" uk-slider="autoplay: true; autoplay-interval: 5000">
              <ul class="uk-slider-items uk-grid">
                <li class="uk-width-1-1">
                    <div class="image-container-section">
                        <img src="https://api.roomi.co.id/images/home/aset website-06.jpg" alt="TV Image">
                    </div>
                </li>
                <!-- <li class="uk-width-1-1">
                    <div class="image-container-section">
                        <img src="https://api.roomi.co.id/images/home/aset website-05.jpg" alt="Another TV Image">
                    </div>
                </li> -->
                <li class="uk-width-1-1">
                    <div class="image-container-section">
                        <img src="https://api.roomi.co.id/images/home/aset website-04.jpg" alt="Another TV Image">
                    </div>
                </li>
                <li class="uk-width-1-1">
                    <div class="image-container-section">
                        <img src="https://api.roomi.co.id/images/home/aset website-07.jpg" alt="Another TV Image">
                    </div>
                </li>
                <li class="uk-width-1-1">
                    <div class="image-container-section">
                        <img src="https://api.roomi.co.id/images/home/aset website-08.jpg" alt="Another TV Image">
                    </div>
                </li>
              </ul>
            </div>
            <!-- <img class="uk-width-1-1" :src="encodeURI('https://api.roomi.co.id/images/home/aset website-04.jpg')" alt="TV Image"> -->
          </div>
        </div>
      </div>

      <!-- MOBILE -->
    </section>

    <!---------------------------- MOBILE SECTION ----------------------------------------------->
    <div class="uk-hidden@s" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: false;">
      <div class="" uk-slideshow="autoplay: true" >
        <div class="uk-slideshow-items">
          <div>
            <img :src="encodeURI('https://api.roomi.co.id/images/v2/banner/1.jpg')" alt="" uk-cover>
            <div class="uk-position-bottom uk-animation-slide-bottom uk-margin-medium-bottom flex flex-center uk-text-center uk-margin-medium-left uk-margin-medium-right">
            </div>
          </div>
        </div>
      </div>

      <div class="uk-grid uk-child-width-1-2 uk-grid-collapse" uk-grid>
        <div>
          <img class="uk-width-1-1 uk-height-1-1 uk-object-cover" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;"
            :src="this.encodeURI('https://api.roomi.co.id/images/v2/beauty.jpg')"
            alt="TV Image">
        </div>
        <div>
          <img class="uk-width-1-1 uk-height-1-1 uk-object-cover" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;"
            :src="this.encodeURI('https://api.roomi.co.id/images/v2/beauty-text.jpg')"
            alt="TV Image">
        </div>
      </div>

      <div class="uk-grid uk-child-width-1-2 uk-grid-collapse" uk-grid>
        <!-- <div>
          <div class="uk-flex uk-flex-center uk-flex-middle uk-background-muted uk-height-1-1 uk-width-1-1">
            <p class="uk-text-center uk-margin-remove uk-text-large uk-text-bold uk-text-primary">Commercial</p>
          </div>
        </div> -->
        <div>
          <img class="uk-width-1-1 uk-height-1-1 uk-object-cover" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;"
            :src="this.encodeURI('https://api.roomi.co.id/images/v2/industrial-text.jpg')"
            alt="TV Image">
        </div>
        <div>
          <img class="uk-width-1-1 uk-height-1-1 uk-object-cover" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;"
            :src="this.encodeURI('https://api.roomi.co.id/images/v2/industrial.jpg')"
            alt="TV Image">
        </div>
      </div>
      <div class="uk-grid uk-child-width-1-2 uk-grid-collapse" uk-grid>
        <div>
          <img class="uk-width-1-1 uk-height-1-1 uk-object-cover" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;"
            :src="this.encodeURI('https://api.roomi.co.id/images/v2/home-office.jpg')"
            alt="TV Image">
        </div>
        <div>
          <img class="uk-width-1-1 uk-height-1-1 uk-object-cover" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;"
            :src="this.encodeURI('https://api.roomi.co.id/images/v2/home-office-text.jpg')"
            alt="TV Image">
        </div>
      </div>
      <!-- <div class="uk-container uk-margin-medium-top">
        <div class="uk-grid uk-text-center uk-grid-small" uk-grid>
          <p class="uk-width-1-1  uk-text-bold font-description">
            Transforming Your Home Experience
          </p>
          <p>PT. Sumber Digital Media is a retail company in Indonesia specializing in the sale of electronic goods and home appliances</p>
        </div>
      </div> -->

      <div>
        <img class="uk-width-1-1 uk-height-1-1 uk-object-cover" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;" :src="this.encodeURI('https://api.roomi.co.id/images/v2/smart-choice.jpg')" alt="TV Image">
      </div>
      <div class="uk-padding">
        <ul uk-accordion class="custom-accordion custom-icons uk-text-bold">
          <li>
            <a class="uk-accordion-title" href>Our Store</a>
            <div class="uk-accordion-content">
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            </div>
          </li>
          <li>
              <a class="uk-accordion-title" href>Location</a>
              <div class="uk-accordion-content">
                  <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor reprehenderit.</p>
              </div>
          </li>
          <li>
              <a class="uk-accordion-title" href>About Us</a>
              <div class="uk-accordion-content">
                  <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat proident.</p>
              </div>
          </li>
          <li>
              <a class="uk-accordion-title" href>Tanaka</a>
              <div class="uk-accordion-content">
                  <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat proident.</p>
              </div>
          </li>
        </ul>
      </div>
    </div>

    <section class="uk-section uk-visible@s" id="section-two">
      <div class="">
        <div uk-slideshow="animation: push; parallax: true; parallax-start: 100%; parallax-end: 100%;">
          <div class="uk-slideshow-items" style="height: 200px">
            <div>
              <div class="uk-position-bottom uk-animation-slide-bottom flex flex-center uk-text-center">
                <p class="uk-margin-remove uk-heading-medium"> </p>
              </div>
            </div>
            <div>
              <div class="uk-position-bottom uk-animation-slide-bottom uk-margin-medium-bottom flex flex-center uk-text-left">
                <p class="uk-margin-remove uk-heading-large uk-text-bold">Smart Living, Simplified.</p>
              </div>
            </div>
          </div>
        </div>
        <div uk-slideshow="animation: push; parallax: true;">
          <div class="uk-slideshow-items" style="height: 100px" >
            <div uk-slideshow-parallax="x: -1400, 400">
              <div class="uk-position-bottom uk-animation-slide-bottom flex flex-center uk-text-center">
                <p class="uk-margin-remove uk-heading-large uk-text-bold">Elevate Your Lifestyle</p>
              </div>
            </div>
            <div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="uk-section uk-visible@s" id="section-three">
      <!-- DESKTOP -->
      <div class="uk-container uk-text-center uk-visible@s">
        <p uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;" class=" uk-text-black uk-text-bold uk-text-primary">Discover Excellence</p>
        <p uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;" class="font-sub-head uk-text-bold uk-text-black">Smart Homes, Smarter Living</p>
        <p uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;" class="font-description uk-margin-large-left uk-margin-large-right uk-text-light">Discover our selection of cutting-edge smart home appliances that combine style and function, designed to make your life easier and more comfortable.</p>
        <div class="uk-grid uk-grid-large" uk-grid uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">
          <div class="uk-width-1-4@s" v-for="(product, index) in discoverData" :key="index">
            <button @click="openCategory(product.url)" class="uk-button uk-button-link uk-margin-small-top uk-text-bold">
              <img class="uk-margin-small-bottom uk-card uk-card-hover" @click="openCategory(product.url)" :src="product.image" :alt="product.title" >
              {{  product.title }}
            </button>
            <!-- <p class="uk-margin-remove-bottom uk-text-default uk-text-bold">{{  product.title }}</p> -->
            <!-- <p class="uk-margin-remove-top">Rp. 150.000</p> -->
          </div>
        </div>
      </div>

      <!-- MOBILE -->
      <!-- <div class="uk-container uk-text-center uk-hidden@s uk-margin-xlarge-top">
        <p uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;" class=" uk-text-black uk-text-bold uk-text-primary uk-margin-xlarge-top">Discover Excellence</p>
        <p uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;" class="font-sub-head uk-text-bold uk-text-black">Smart Homes, Smarter Living</p>
        <p uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;" class="font-description uk-margin-large-left uk-margin-large-right uk-text-light">Discover our selection of cutting-edge smart home appliances that combine style and function, designed to make your life easier and more comfortable.</p>
        <div class="uk-grid uk-child-width-1-2 uk-grid-small" uk-grid uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">
          <div class="" v-for="(product, index) in discoverData" :key="index">
            <button @click="openCategory(product.url)" class="uk-button uk-button-link uk-margin-small-top uk-text-bold">
              <img class="uk-margin-small-bottom uk-card uk-card-hover" @click="openCategory(product.url)" :src="product.image" :alt="product.title" >
              {{  product.title }}
            </button>
          </div>
        </div>
      </div> -->
    </section>

    <h1 class="uk-heading-divider uk-visible@s"></h1>

    <section class="uk-section uk-visible@s" id="section-four">
      <!-- DESKTOP -->
      <div class="uk-container uk-visible@s">
        <div class="uk-grid" uk-grid>
          <div class="uk-width-1-2@s">
            <!-- <p class="uk-text-bold uk-heading-medium" uk-scrollspy="cls: uk-animation-slide-right; delay: 500; repeat: true;">01</p> -->
            <!-- <p class="uk-margin-medium-top uk-text-default" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Discover CCTV</p> -->
            <p class="uk-heading-small uk-text-bold uk-margin-large-top" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Hairdryer</p>
            <p class="font-description uk-text-light" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Our high-end hairdryers combine precision engineering and sleek design to deliver fast, efficient drying while minimizing heat damage. Whether for professional styling or everyday use, ROOMI hairdryers ensure exceptional performance and a flawless finish, redefining your hair care experience.</p>
            <button @click="openCategory('hairdryer')" class="uk-button uk-button-primary" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">See More</button>
          </div>
          <div class="uk-width-1-2@s">
            <img class="uk-width-1-1 rounded-lg" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;" :src="this.encodeURI('https://api.roomi.co.id/images/home/aset website-09.jpg')" alt="TV Image">
          </div>

          <div class="uk-width-1-2@s">
            <img class="uk-width-1-1 rounded-lg" :src="require('../assets/images/home/tv.jpg')" alt="TV Image">
          </div>
          <div class="uk-width-1-2@s">
            <!-- <p class="uk-text-bold uk-heading-medium" uk-scrollspy="cls: uk-animation-slide-left; delay: 500; repeat: true;">02</p> -->
            <!-- <p class="uk-margin-medium-top uk-text-default" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Discover TV</p> -->
            <p class="uk-heading-small uk-text-bold uk-margin-large-top" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Smart TV</p>
            <p class="font-description uk-text-light" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">At ROOMI, we are dedicated to enhancing your entertainment experience with our premium smart TVs. Designed for exceptional picture quality and seamless connectivity, our smart TVs bring your favorite content to life with advanced features and immersive clarity.</p>
            <button @click="openCategory('smart-tv')" class="uk-button uk-button-primary" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">See More</button>
          </div>

          <div class="uk-width-1-2@s">
            <!-- <p class="uk-text-bold uk-heading-medium" uk-scrollspy="cls: uk-animation-slide-right; delay: 500; repeat: true;">01</p> -->
            <!-- <p class="uk-margin-medium-top uk-text-default" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Discover CCTV</p> -->
            <p class="uk-heading-small uk-text-bold uk-margin-large-top" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Smart Camera</p>
            <p class="font-description uk-text-light" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">At ROOMI, we are dedicated to enhancing security through advanced technology. We offer a range of high-end smart cameras, including both indoor and outdoor CCTV systems, designed to provide comprehensive surveillance and ensure the safety of your home or business.</p>
            <button @click="openCategory('smart-camera')" class="uk-button uk-button-primary" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">See More</button>
          </div>
          <div class="uk-width-1-2@s">
            <img class="uk-width-1-1 rounded-lg" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;" :src="require('../assets/images/home/cctv.jpeg')" alt="TV Image">
          </div>
        </div>
      </div>

      <!-- MOBILE -->
      <!-- <div class="uk-margin-left uk-margin-right uk-hidden@s">
        <div class="uk-grid" uk-grid>
          <div class="uk-width-1-2@s uk-margin-large-top">
            <img class="uk-width-1-1 rounded-lg" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;" :src="this.encodeURI('https://api.roomi.co.id/images/home/aset website-09.jpg')" alt="TV Image">
          </div>
          <div class="uk-width-1-2@s uk-text-center">
            <p class="uk-text-large uk-text-bold" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Hairdryer</p>
            <p class="uk-text-light" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Our high-end hairdryers combine precision engineering and sleek design to deliver fast, efficient drying while minimizing heat damage. Whether for professional styling or everyday use, ROOMI hairdryers ensure exceptional performance and a flawless finish, redefining your hair care experience.</p>
            <button @click="openCategory('hairdryer')" class="uk-button uk-button-primary" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">See More</button>
          </div>

          <div class="uk-width-1-2@s uk-margin-large-top">
            <img class="uk-width-1-1 rounded-lg" :src="require('../assets/images/home/tv.jpg')" alt="TV Image">
          </div>
          <div class="uk-width-1-2@s uk-text-center">
            <p class="uk-text-large uk-text-bold" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Smart TV</p>
            <p class="uk-text-light" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">At ROOMI, we are dedicated to enhancing your entertainment experience with our premium smart TVs. Designed for exceptional picture quality and seamless connectivity, our smart TVs bring your favorite content to life with advanced features and immersive clarity.</p>
            <button @click="openCategory('smart-tv')" class="uk-button uk-button-primary" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">See More</button>
          </div>

          <div class="uk-width-1-2@s">
            <img class="uk-width-1-1 rounded-lg" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;" :src="require('../assets/images/home/cctv.jpeg')" alt="TV Image">
          </div>
          <div class="uk-width-1-2@s uk-text-center">
            <p class="uk-text-large uk-text-bold" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Smart Camera</p>
            <p class="uk-text-light" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">At ROOMI, we are dedicated to enhancing security through advanced technology. We offer a range of high-end smart cameras, including both indoor and outdoor CCTV systems, designed to provide comprehensive surveillance and ensure the safety of your home or business.</p>
            <button @click="openCategory('smart-camera')" class="uk-button uk-button-primary" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">See More</button>
          </div>
        </div>
      </div> -->
    </section>

    <h1 class="uk-heading-divider uk-visible@s"></h1>

    <section class="uk-section uk-visible@s" id="section-five">
      <!-- DESKTOP -->
      <div class="uk-container uk-visible@s">
        <div class="uk-grid" uk-grid>
          <div class="uk-width-1-1@s uk-text-center">
            <p class="uk-text-default" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Timeless Appeal</p>
            <p class="uk-heading-small uk-text-bold" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Explore Our Collections</p>
            <p class="font-description uk-text-light uk-margin-large-left uk-margin-large-right" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Discover the perfect addition to your smart home setup with our curated collections of smart appliances, audio, and security products.</p>
          </div>
        </div>
        <div class="uk-flex uk-flex-between uk-margin" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">
          <!-- <button class="uk-button uk-button-link uk-text-primary">All</button> -->
          <!-- <button @click="openCategory('smart-led')" class="uk-button uk-button-link">Smart Led</button>
          <button @click="openCategory('smart-camera')" class="uk-button uk-button-link">Smart Camera</button>
          <button @click="openCategory('smart-tv')" class="uk-button uk-button-link">Smart TV</button>
          <button @click="openCategory('android-box')" class="uk-button uk-button-link">Android Box</button>
          <button @click="openCategory('speaker')" class="uk-button uk-button-link">Speaker</button> -->
          <!-- <button @click="openCategory('digital-led-tv')" class="uk-button uk-button-link">Digital Led TV</button> -->
        </div>
        <div class="uk-grid" uk-grid uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">
          <div class="uk-width-1-3@s uk-text-center" v-for="product in collectionData" :key="product.image">
            <img @click="openCategory(product.title)" class="uk-width-1-1 cursor uk-card uk-card-hover" :src="product.image" alt="TV Image">
          </div>
        </div>
      </div>

      <!-- MOBILE -->
      <!-- <div class="uk-margin-left uk-margin-right uk-hidden@s">
        <div class="uk-grid" uk-grid>
          <div class="uk-width-1-1@s uk-text-center">
            <p class="uk-margin-large-top uk-text-default" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Timeless Appeal</p>
            <p class="uk-text-large uk-margin-remove-top uk-text-bold" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Explore Our Collections</p>
            <p class="uk-text-light uk-margin-large-left uk-margin-large-right" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Discover the perfect addition to your smart home setup with our curated collections of smart appliances, audio, and security products.</p>
          </div>
        </div>
        <div class="uk-grid" uk-grid uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">
          <div class="uk-width-1-3@s uk-text-center" v-for="product in collectionData" :key="product.image">
            <img @click="openCategory(product.title)" class="uk-width-1-1 cursor uk-card uk-card-hover" :src="product.image" alt="TV Image">
          </div>
        </div>
      </div> -->
    </section>

    <h1 class="uk-heading-divider uk-visible@s"></h1>

    <section class="uk-section uk-visible@s" id="section-six">
      <!-- DESKTOP -->
      <div class="uk-container uk-visible@s">
        <div class="uk-grid uk-grid-large" uk-grid>
          <div class="uk-width-1-3@s uk-flex uk-flex-middle">
            <div class="uk-flex uk-flex-middle uk-flex-center" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">
              <div class="uk-card uk-card-default uk-card-body uk-text-center">
                  <img width="60" height="60" class="circle-image" :src="require('../assets/icon/apple-icon-60x60.png')" alt="TV Image">
                  <div class="">
                    <p class="uk-margin-small-bottom uk-text-large">Roomi Indonesia</p>
                    <FontAwesomeIcon :icon="faStar" color="orange" class="fa-lg uk-margin-small-right" />
                    <FontAwesomeIcon :icon="faStar" color="orange" class="fa-lg uk-margin-small-right" />
                    <FontAwesomeIcon :icon="faStar" color="orange" class="fa-lg uk-margin-small-right" />
                    <FontAwesomeIcon :icon="faStar" color="orange" class="fa-lg uk-margin-small-right" />
                    <FontAwesomeIcon :icon="faStar" color="orange" class="fa-lg" />
                    <p class="font-white uk-text-muted uk-margin-small-top">Based on 16 Reviews</p>
                    <img width="180" height="180" :src="require('../assets/icon/powered_by_google.png')" alt="TV Image">
                  </div>
              </div>
            </div>

          </div>
          <div class="uk-width-2-3@s">
            <div>
              <p class="" uk-scrollspy="cls: uk-animation-slide-left; delay: 500; repeat: true;">The Allure of Our Collection</p>
              <p class="uk-heading-small uk-text-bold  uk-margin-remove" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">What Our Customers Say</p>
              <p class="font-description uk-text-light " uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Read what our satisfied customers have to say about their experience with ROOMI.</p>
              <button @click="goTo('https://search.google.com/local/writereview?placeid=ChIJcV-j6cL5aS4RiewxHdWEYPo')" class="uk-button uk-button-primary" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Review us on <FontAwesomeIcon :icon="faGoogle" color="white" class="fa-lg" /></button>
            </div>
            <!-- <div>
              <p class="font-description uk-text-light text-white" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Read what our satisfied customers have to say about their experience with ROOMI.</p>
              <div class="uk-flex uk-flex-middle uk-flex-center" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">
                <img width="60" height="60" class="circle-image" :src="require('../assets/images/home/office.jpeg')" alt="TV Image">
                <div class="uk-text-left uk-margin-left">
                  <p class="text-white uk-margin-remove">Erwin</p>
                  <p class="text-white uk-margin-remove uk-text-small uk-text-muted">Influencer</p>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <!-- MOBILE -->
      <!-- <div class="uk-margin-left uk-margin-right uk-hidden@s">
        <div class="uk-grid uk-grid-large" uk-grid>
          <div class="uk-width-1-2@s">
            <div class="uk-card uk-card-default uk-card-body uk-text-center">
              <img width="60" height="60" class="circle-image" :src="require('../assets/icon/apple-icon-60x60.png')" alt="TV Image">
              <div class="">
                <p class="uk-margin-small-bottom uk-text-large">Roomi Indonesia</p>
                <FontAwesomeIcon :icon="faStar" color="orange" class="fa-lg uk-margin-small-right" />
                <FontAwesomeIcon :icon="faStar" color="orange" class="fa-lg uk-margin-small-right" />
                <FontAwesomeIcon :icon="faStar" color="orange" class="fa-lg uk-margin-small-right" />
                <FontAwesomeIcon :icon="faStar" color="orange" class="fa-lg uk-margin-small-right" />
                <FontAwesomeIcon :icon="faStar" color="orange" class="fa-lg" />
                <p class="font-white uk-text-muted uk-margin-small-top">Based on 16 Reviews</p>
                <img width="180" height="180" :src="require('../assets/icon/powered_by_google.png')" alt="TV Image">
              </div>
            </div>
          </div>
          <div class="uk-width-1-2@s uk-text-center">
            <div>
              <div>
                <p class="  uk-text-bold" uk-scrollspy="cls: uk-animation-slide-left; delay: 500; repeat: true;">The Allure of Our Collection</p>
                <p class="font-sub-head uk-text-bold  uk-margin-remove" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">What Our Customers Say</p>
                <p class="font-description uk-text-light " uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Read what our satisfied customers have to say about their experience with ROOMI.</p>
                <button @click="goTo('https://search.google.com/local/writereview?placeid=ChIJcV-j6cL5aS4RiewxHdWEYPo')" class="uk-button uk-text-lowercase uk-button-primary" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Review us on <FontAwesomeIcon :icon="faGoogle" color="white" class="fa-lg" /></button>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </section>

    <h1 class="uk-heading-divider uk-visible@s"></h1>

    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import NavigationBar from "@/components/NavigationBar.vue";
import Footer from "@/components/Footer.vue";
import axios from "axios";
import UIkit from "uikit";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { faGoogle } from '@fortawesome/free-brands-svg-icons'

export default {
  name: "Home",
  assetsSubDirectory: "@/assets",
  components: {
    NavigationBar,
    Footer,
    FontAwesomeIcon
  },
  data() {
    return {
      faStar,
      faGoogle,
      hover: false,
      sliders: [],
      slideshows: [],
      bestSelllers: [
        {
        	backgroundImage: require('../assets/images/home/cctv.jpeg'),
          detailLink: '/product/cctv-roomi-spye-night-motion',
          buyLink: 'https://www.tokopedia.com/roomiid/cctv-roomi-motion-night-vision',
        },
        {
        	backgroundImage: require('../assets/images/home/speaker.jpg'),
          detailLink: '/product/speakerwakanda',
          buyLink: 'https://www.tokopedia.com/roomiid/speaker-bluetooth-portable-roomi-wakanda-8-inch?extParam=src%3Dshop%26whid%3D9378653',
        },
        {
        	backgroundImage: require('../assets/images/home/ottbox.jpeg'),
          detailLink: '/product/roomi-android-box-1-8gb',
          buyLink: 'https://www.tokopedia.com/roomiid/ott-box-roomi-android-tv-1-8gb-1ff9a?extParam=src%3Dshop%26whid%3D9378653',
        },
        {
        	backgroundImage: require('../assets/images/home/tv.jpg'),
          detailLink: '/product/smart-led-tv-32',
          buyLink: 'https://www.tokopedia.com/roomiid/smart-tv-digital-32-inch-roomi-android-11-smart-tv?extParam=src%3Dshop%26whid%3D9378653',
        },
      ],
      panelContent: [
        {
        	backgroundColor: 'rgb(234, 236, 241)',
        	backgroundImage: require('../assets/images/gambar store roomi ex (2).png'),
        	color: 'rgb(64, 63, 65)',
        	boxShadowColor: 'rgb(215, 217, 229)',
        	header: 'ROOMI',
        	subHeader: 'experience Store',
          fontsize: '10px',
        	link: '/store_roomi',
        	name: 'lumio_content',
         is_out_link: false,
        },
        {
          // backgroundColor: 'rgb(241, 242, 243)',
          backgroundColor: "rgb(234, 236, 241)",
          backgroundImage: require("../assets/oie_qJ0LzuLRQVTi.png"),
          color: "rgb(64, 63, 65)",
          boxShadowColor: "rgb(222, 224, 230)",
          header: "spye",
          subHeader: "your home security",
          fontsize: '10px',
          link: "/spye-series",
          name: "spye_content",
          is_out_link: false,
        },

        {
          backgroundColor: "rgb(36, 70, 124)",
          backgroundImage: require("../assets/iphone_x2.png"),
          color: "rgb(255, 255, 255)",
          boxShadowColor: "rgb(106, 118, 160)",
          header: "get app",
          subHeader: "ios & android",
          link: "https://play.google.com/store/apps/details?id=com.techme.techme",
          name: "download_content",
          is_out_link: true,
        },
        {
          backgroundColor: "transparent",
          backgroundImage: require("../assets/woman-in-white-blazer-holding-tablet-computer-789822EDIT.jpg"),
          color: "rgb(64, 63, 65)",
          boxShadowColor: "rgb(210, 214, 226)",
          header: "tech support",
          subHeader: "troubleshoot",
          link: "https://online.anyflip.com/hbjak/yyfw/mobile/index.html",
          name: "support_content",
          is_out_link: false,
        },
      ],
      loadingSlider: false,
      loadingSlideshow: false,
      discoverData: [
        {
          title: 'Smart Camera',
          url: 'smart-camera',
          image: require('../assets/images/home/cctv.jpeg')
        },
        {
          title: 'Smart TV',
          url: 'smart-tv',
          image: require('../assets/images/home/tv.jpg')
        },
        {
          title: 'Speaker',
          url: 'speaker',
          image: require('../assets/images/home/speaker.jpg')
        },
        {
          title: 'OTT Box',
          url: 'android-box',
          image: require('../assets/images/home/ottbox.jpeg')
        }
      ],
      collectionData: [
        {
          title: 'hairdryer',
          image: this.encodeURI('https://api.roomi.co.id/images/home/aset website-09.jpg')
        },
        {
          title: 'smart-camera',
          image: require('../assets/images/home/cctv.jpeg')
        },
        {
          title: 'Smart-TV',
          image: require('../assets/images/home/tv.jpg')
        },
        {
          title: 'Speaker',
          image: require('../assets/images/home/speaker.jpg')
        },
        {
          title: 'android-box',
          image: require('../assets/images/home/ottbox.jpeg')
        }
      ]
    };
  },
  computed: {
    slidersCount: function () {
      return Number(this.sliders.length);
    },
  },
  mounted() {
    this.getBannerSlider();
    this.getSlideShow();
  },
  methods: {
    getBannerSlider() {
      this.loadingSlider = true;
      const params = {
        type: "slider",
      };
      const paramsString = new URLSearchParams(params).toString();
      axios
        .get(`${process.env.VUE_APP_API_ROOMI_URL}banner?${paramsString}`)
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (data.success) {
              this.loadingSlider = false;
              const temp = [];
              for (const item of data.data) {
                temp.push({
                  link: item.link,
                  backgroundImage: item.image,
                  name: item.name,
                });
              }
              this.sliders = temp;
            } else {
              UIkit.notification({
                status: "danger",
                message: "Something wen't wrong!",
              });
            }
          } else {
            UIkit.notification({
              status: "danger",
              message: "Something wen't wrong!",
            });
          }
        })
        .catch((err) => {
          UIkit.notification({
            status: "danger",
            message: "Something wen't wrong!",
          });
        });
    },
    getSlideShow() {
      this.loadingSlideshow = true;
      const params = {
        type: "slideshow",
      };
      const paramsString = new URLSearchParams(params).toString();
      axios
        .get(`${process.env.VUE_APP_API_ROOMI_URL}banner?${paramsString}`)
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (data.success) {
              this.loadingSlideshow = false;
              const temp = [];
              for (const item of data.data) {
                temp.push({
                  link: item.link,
                  backgroundImage: item.image,
                  name: item.name,
                });
              }
              this.slideshows = temp;
            } else {
              UIkit.notification({
                status: "danger",
                message: "Something wen't wrong!",
              });
            }
          } else {
            UIkit.notification({
              status: "danger",
              message: "Something wen't wrong!",
            });
          }
        })
        .catch((err) => {
          UIkit.notification({
            status: "danger",
            message: "Something wen't wrong!",
          });
        });
    },
    learnButton(url) {
      this.$router.push(url);
    },
    buyButton(url) {
      window.open(url, '_blank');
    },
    openCategory(category){
			this.$router.push({ name: 'category', params: { id: category } });
		},
    encodeURI(url) {
      return encodeURI(url);
    },
    goTo(url){
      window.open(url, '_blank');
    }
  },
};
</script>

<style scoped>

#section-one .slideshow-item {
  min-height: 100%;
  width: 100%;
  background-size: 100%;
  object-fit: contain;
  background-position: top center;
  background-repeat: no-repeat;
  border-radius: 20px;
}

.slideshow-one-text {
  max-width: 50%;
}

.slideshow-one-text h1 {
  margin-bottom: 0;
  margin-top: 0;
  font-family: "Open Sans";
  font-weight: 500;
  padding-bottom: 5%;
  font-size: 46px;
  line-height: 52px;
  letter-spacing: 4px;
  text-transform: uppercase;
}

.slideshow-one-text h4 {
  font-size: 1.3vw;
  letter-spacing: 0.1vw;
  font-family: "Open Sans";
  font-weight: 500;
  line-height: 2vw;
  margin-bottom: 0.5vw;
  padding-bottom: 0;
  text-transform: uppercase;
}

.slideshow-item a {
  height: 40px;
  width: 180px;
  font-size: 17px;
  vertical-align: middle;
  padding: 0 20px 0 14px;
  border-left: 6px solid rgb(45, 61, 120);
  background-color: transparent;
  font-weight: 500;
}

.slideshow-item a:hover {
  background-color: rgba(45, 61, 120, 0.9);
}

@media screen and (min-width: 641px) {
  #section-one .uk-slideshow {
    max-height: 415px !important;
  }
  #section-one .uk-slideshow-items {
    max-height: 415px !important;
  }
}

@media screen and (max-width: 640px) {
  #section-one .uk-slideshow {
    max-height: 220px !important;
  }
  #section-one .uk-slideshow-items {
    max-height: 120px !important;
  }

  #section-one .slideshow-item {
    border-radius: 10px !important;
  }

  #section-one {
    padding: 0px;
  }
}

@media screen and (max-width: 425px) {
  #section-one .uk-slideshow-items {
    min-height: 360px !important;
  }
}

@media screen and (max-width: 375px) {
  #section-one .uk-slideshow-items {
    min-height: 120px !important;
  }
}

@media screen and (max-width: 639px) {
  #section-one .slideshow-item {
    height: auto;
    background-size: 100%;
    background-position-x: left;
    background-position-y: 0;
  }

  .slideshow-one-text {
    top: 30%;
    left: 45%;
    margin-top: 5%;
    margin-left: 5%;
    max-width: 90%;
  }

  .slideshow-one-text h4 {
    font-size: 14px;
    line-height: 14px;
    text-align: left;
  }

  .slideshow-one-text h1 {
    font-size: 24px;
    line-height: 24px;
    text-align: left;
  }

  .slideshow-item a {
    background-color: rgba(45, 61, 120, 0.9);
    line-height: 25px;
    height: 25px;
    width: 90px;
    font-size: 10px;
    padding-left: 0;
    padding-right: 0;
    border-left-width: 0px;
    float: left;
  }
}

@media screen and (max-width: 375px) {
  #section-one .uk-slideshow-items {
    min-height: 120px !important;
  }
}

@media screen and (min-width: 640px) and (max-width: 960px) {
  .slideshow-one-text h1 {
    font-size: 28px;
    line-height: normal;
  }

  .slideshow-one-text h4 {
    font-size: 12px;
    line-height: normal;
  }

  .slideshow-item a {
    width: 150px;
    font-size: 12px;
  }
}

@media screen and (min-width: 1870px) {
  .slideshow-item a {
    width: 200px;
  }
}

ul.uk-dotnav li.uk-active a {
  background-color: rgb(45, 61, 120) !important;
  border-color: rgb(45, 61, 120) !important;
  opacity: 90%;
}

ul.uk-dotnav li a {
  background-color: rgb(240, 237, 234) !important;
  border-color: rgb(240, 237, 234) !important;
  opacity: 90%;
}

#section-one ul.uk-dotnav > * {
  padding-left: 5px !important;
}

/* End of #1 section */
.panel-default {
  cursor: pointer;
}

#panel-default-1,
#panel-default-2 {
  background-size: 30%;
  background-position-x: calc(100% - 20px);
  background-position-y: center;
  background-repeat: no-repeat;
}

/* #panel-default-3 {
	background-size: 50%;
	background-position-x: calc(100% - 20px);
	background-position-y: calc(100% + 30px);
	background-repeat: no-repeat;
}

#panel-default-4 {
	background-size: 150%;
	background-position-x: left;
	background-position-y: center;
	background-repeat: no-repeat;
} */

.support_content_style {
  background-size: 150% !important;
  background-position-x: left !important;
  background-position-y: center !important;
  background-repeat: no-repeat !important;
}

.download_content_style {
  background-size: 50% !important;
  background-position-x: calc(100% - 20px) !important;
  background-position-y: calc(100% + 30px) !important;
  background-repeat: no-repeat !important;
}

.panel-text {
  margin-bottom: 5%;
  margin-left: calc(5% + 10px);
  padding-left: 3%;
  width: -webkit-fill-available !important;
}

a.panel-text:hover {
  text-decoration: none;
}

.panel-text h2,
.panel-text span {
  text-transform: uppercase;
}

.panel-text h2 {
  letter-spacing: 2.5px;
  font-weight: 300;
  font-size: 30px;
  transform: scaleX(1.1);
  transform-origin: left;
}

.panel-text span {
  letter-spacing: 2.8px;
  font-size: 16px;
}

.slideshow-two-content .uk-position-cover {
  height: 100%;
  width: auto;
  background-size: cover;
  object-fit: fill;
  background-repeat: no-repeat;
}

.slideshow-two-header {
  max-width: 100%;
  padding: 15px 35px 10px 35px;
}

.slideshow-two-header h5 {
  margin-bottom: unset;
  padding: 20px 35px 10px 35px;
  letter-spacing: 2px;
}

.slideshow-two-text {
  top: calc(10% + 15px);
  padding-left: 35px;
  padding-right: 35px;
}

.slideshow-two-text h1 {
  margin-bottom: unset;
  font-size: 3.4vw;
  letter-spacing: 3px;
  word-spacing: 2px;
  font-weight: 400;
  line-height: 1;
}

.slideshow-two-text span {
  letter-spacing: 2.5px;
  font-size: large;
}

.slideshow-two-content a.uk-button {
  margin: 20px 35px;
  height: 45px;
  font-size: 1.2vw;
  line-height: 45px;
  /* border-left: 10px solid rgba(41, 55, 108, 0.75) !important; */
  background-color: rgb(45, 61, 120) !important;
  padding: 0 30px 0 20px;
  color: #fff;
}

.slideshow-two-content a.uk-button:hover {
  background-color: rgb(45, 61, 120) !important;
}

@media screen and (max-width: 639px) {
  #section-two {
    margin-top: 0 !important;
  }

  #section-two .panel-container {
    width: 100%;
  }

  .panel-default {
    padding: 20% 0;
  }

  .panel-text {
    margin-left: 20px;
    margin-bottom: 20px;
    padding-left: 15px;
  }

  .panel-text h2 {
    font-size: 20px;
  }

  .panel-text span {
    font-size: 12px;
  }

  #slideshow-two {
    margin-top: 40px;
  }

  .slideshow-two-panel {
    padding-bottom: 100%;
  }

  .slideshow-two-text h1 {
    font-size: 24px;
  }

  .slideshow-two-text span {
    font-size: 12px;
  }

  .slideshow-two-content a.uk-button {
    background-color: rgba(45, 61, 120, 0.9) !important;
    height: 30px;
    font-size: 14px;
    line-height: 30px;
  }
}

@media screen and (min-width: 640px) {
  .panel-default {
    padding: 20% 0;
  }
}

.main-slideshow {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  z-index: 1;
  margin: 0;
  padding: 0;
}

.image-container-section {
  /* height: 350px; Set a fixed height for the image containers */
  overflow: hidden;
}

.image-container-section img {
  width: 100%; /* Ensure the image fills the container */
  height: 100%; /* Ensure the image fills the container */
  object-fit: cover; /* Maintain aspect ratio while covering the container */
  /* border-radius: 20px; */
}

.image-overlay {
  position: absolute; /* Position text absolutely relative to parent container */
  top: 0; /* Position text at the top of the container */
  left: 0; /* Position text at the left of the container */
  width: 100%; /* Make the text span the entire width of the container */
  padding: 20px; /* Add padding to the text */
  color: white; /* Set text color */
  background-color: rgba(0, 0, 0, 0.5); /* Add semi-transparent background */
  text-align: left; /* Center-align text */
}

.text-white {
  color: #fff;
}

.button-outline {
  border-radius: 10px;
  font-weight: bold;
  color: #23467c;
  border: 2px solid #23467c;
}

.button-solid {
  border-radius: 10px;
  font-weight: bold;
  color: #fff;
  background-color: #23467c;
  border: 2px solid #23467c;
}

@media screen and (max-width: 640px) {
  .button-outline {
    border-radius: 10px;
    font-weight: bold;
    color: #23467c;
    border: 2px solid #23467c;
    font-size: 8px !important;
    padding: 0px 8px;
    line-height: 18px !important;
  }

  .button-solid {
    border-radius: 10px;
    font-weight: bold;
    color: #fff;
    background-color: #23467c;
    border: 2px solid #23467c;
    font-size: 8px !important;
    padding: 0px 8px;
    line-height: 18px !important;
  }
}

@media screen and (max-width: 640px) {
  .image-wrapper {
      position: relative;
      width: 100%;
      height: 200px;
  }

  .image-wrapper img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover; /* Ensure the image covers the entire container */
      border-radius: 20px; /* Apply border radius */
  }
}

/* SECTION TWO */
@media screen and (max-width: 640px) {
  #section-two .uk-container {
    padding: 0px 20px !important;
  }

  #section-three .uk-container {
    padding: 0px 20px !important;
  }
}

/* SECTION THREE */
@media screen and (max-width: 640px) {
  #section-three .text-store {
    margin-left: 30px !important;
    line-height: 1.2;
    padding: 20px !important;
  }

  #section-three .text-store p{
    font-size: 14px;
  }

  #section-three .text-store h2{
    font-size: 20px;
  }
}

.custom-accordion li {
  border-bottom: 1px solid #e5e5e5; /* Light gray divider line */
  list-style: none;
  padding: 15px 0px 15px 0px;
}

.custom-accordion .uk-open .uk-icon[uk-icon="icon: chevron-down"] {
  transform: rotate(-180deg); /* Changes the icon to point upwards */
  transition: transform 0.3s ease;
}


/* Hide the default icons */
.custom-icons .uk-accordion-title::before {
  content: none;
}

/* Add the down arrow (default) */
.custom-icons .uk-accordion-title::after {
  content: '';
  width: 1em;
  height: 1em;
  float: right;
  margin-left: auto;
  background-image: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"%3E%3Cpolyline points="6 9 12 15 18 9"%3E%3C/polyline%3E%3C/svg%3E');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: transform 0.3s ease;
}

/* Rotate to up arrow when active */
.custom-icons .uk-open .uk-accordion-title::after {
  transform: rotate(180deg); /* Arrow points up */
}

</style>